exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody{\n\toverflow-x: hidden;\n}\nbody[data-layout=horizontal] .navbar-header{\n\tmax-width: 100%;\n}\n", ""]);

// exports
